import { render, staticRenderFns } from "./CartItemNew.vue?vue&type=template&id=3dbbf1ad&scoped=true&"
import script from "./CartItemNew.vue?vue&type=script&lang=js&"
export * from "./CartItemNew.vue?vue&type=script&lang=js&"
import style0 from "./CartItemNew.vue?vue&type=style&index=0&id=3dbbf1ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbbf1ad",
  null
  
)

export default component.exports